import { Dispatch, useReducer } from "react";

export type SectionToggleState = [
  /** The current section value. */
  string,

  /** Function to set the current section. */
  Dispatch<string>,
];

function sectionReducer(state: any, section: string): string | null {
  if (state !== section) {
    return section;
  }
  return null;
}

export function useSectionToggle(initialSection = null): SectionToggleState {
  return useReducer(sectionReducer, initialSection);
}

export type SectionHelpers = {
  isOpen: boolean;
  onToggle: () => void;
};

export function useSectionHelper(
  sectionToggleState: SectionToggleState,
  section: string | null,
): SectionHelpers {
  const [currentSection, setSection] = sectionToggleState;
  const isOpen = currentSection === section;
  const onToggle = () => setSection(section);

  return { isOpen, onToggle };
}
